import { useDispatch } from 'react-redux';
import { Grid, TextField } from "@material-ui/core";
import { load } from '../../store/slices/configSlice';

function MagicDial(props) {
    const dispatch = useDispatch();

    if (!props.config.SmartDial) {
        return null
    }

    const updateConfig = (key, val) => {
        let newConfig = JSON.parse(JSON.stringify(props.config));
        newConfig.SmartDial.CalendarWeight[key] = parseFloat(val)
        dispatch(load(newConfig))
    }

    let totalSlots = 0;
    Object.keys(props.bookings).map(key => {
        totalSlots += (props.bookings[key] * props.config.SmartDial.CalendarWeight[key])
    })
    let totalPerc = 0;
    return (
        <Grid container>
            <Grid container style={{borderBottom: "solid black 1px"}}>
                <Grid item xs={3}>Calendar Name</Grid>
                <Grid item xs={3}>Weighting Multiplier</Grid>
                <Grid item xs={3}>Current Open Slots</Grid>
                <Grid item xs={3}>Estimated % of Calls</Grid>
            </Grid>
            {
                Object.keys(props.config.SmartDial.CalendarNames).map(key => {
                    let val = props.config.SmartDial.CalendarNames[key];
                    let perc = (props.bookings[key] * props.config.SmartDial.CalendarWeight[key]) / totalSlots;
                    perc = Math.round(perc * 10000) / 100
                    totalPerc += perc
                    return (
                        <Grid container key={`grid-smart-${key}`} style={{marginTop: "5px", marginBottom: "5px", borderBottom: "1px solid grey"}}>
                            <Grid item xs={3} style={{marginTop: "5px", display: "flex", flexDirection: "column", justifyContent: "center"}}>{val}</Grid>
                            <Grid item xs={3}>
                                <TextField
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    type={"number"}
                                    value={props.config.SmartDial.CalendarWeight[key]}
                                    onChange={(e) => updateConfig(key, e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={3}>{props.bookings[key]}</Grid>
                            <Grid item xs={3}>{perc} %</Grid>
                        </Grid>
                    )
                })
            }
        </Grid>
    )
}

export default MagicDial;